module.exports = __webpack_public_path__ + "img/terminal-portfolio_box.cc2ee06b.png";